// extracted by mini-css-extract-plugin
module.exports = {"container":"_1K9CW9 mz-sr-category","icon":"abPeq4 mz-sr-category__icon","categoryName":"_1o0EXC mz-sr-category__name"};